import "react-quill/dist/quill.snow.css";
import { classNames } from "primereact/utils";
import styles from "./TextEditor.module.scss";
import { Controller, useFormContext } from "react-hook-form";
import { RenderWhen } from "../../../../infrastructure/components/RenderWhen";
import { useAppContext } from "../../../../../AppContext";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { AppTooltip } from "../../../tooltip/AppTooltip";

import { dvSize } from "../../../../infrastructure/utilities/viewportUnitsUtility";
interface ITextEditorProps {
  name: string;
  label?: React.ReactNode;
  tooltip?: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
  minHeight?: string | number;
  disabled?: boolean;
  width?: string | number;
  minWidth?: string;
}

export const TextEditor = ({
  name,
  label,
  tooltip,
  placeholder,
  required = false,
  className,
  disabled = false,
  width,
  minHeight = "fit-content",
}: ITextEditorProps) => {
  const { control } = useFormContext();
  const { isDesktopOrTablet } = useAppContext();

  if (!width) {
    if (isDesktopOrTablet) {
      width = "600px";
    } else {
      width = dvSize("80dvw");
    }
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <div
          className={classNames(className, styles.root, {
            [styles.root_disabled]: disabled,
          })}
          style={{ width: width, minHeight: minHeight }}
        >
          <RenderWhen condition={!!label}>
            <div
              className={classNames(styles.root_label, {
                [styles.root_label_error]: !!fieldState.error?.message,
              })}
            >
              {label}
              {required ? "*" : ""}
              <AppTooltip content={tooltip} />
            </div>
          </RenderWhen>
          <ReactQuill
            className={styles.root_editor_container_editor}
            theme="snow"
            value={field.value ?? ""}
            onChange={field.onChange}
            placeholder={placeholder}
            readOnly={disabled}
          />
        </div>
      )}
    />
  );
};
